/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AptosNetflowEcosysTokenRequest = {
    period?: AptosNetflowEcosysTokenRequest.period;
    sort?: AptosNetflowEcosysTokenRequest.sort;
    sortDirection?: AptosNetflowEcosysTokenRequest.sortDirection;
    page?: number;
    size?: number;
};

export namespace AptosNetflowEcosysTokenRequest {

    export enum period {
        H24 = 'H24',
        D7 = 'D7',
        D30 = 'D30',
        D90 = 'D90',
        Y1 = 'Y1',
        YTD = 'YTD',
    }

    export enum sort {
        IN = 'IN',
        OUT = 'OUT',
        TOTAL = 'TOTAL',
    }

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

